import { RESOURCES } from '../constants';

export const buttons = {
  selectProductButton: {
    text: 'Select a Product',
  },
  newsletterButton: {
    text: 'Get our newsletter',
    attr: {
      href: 'https://visit.policygenius.com/ub/newslettersignup/',
      rel: '',
      target: '',
    },
  }
};

export const resourcesList = {
  [RESOURCES.INSURANCE_GUIDES]: {
    header: 'Product Learn Centers',
    items: [
      {
        title: 'Life Insurance Learn Center',
        href: 'https://www.policygenius.com/life-insurance/learn/',
      },
      {
        title: 'Health Insurance Learn Center',
        href: 'https://www.policygenius.com/health-insurance/learn/',
      },
      {
        title: 'Disability Insurance Learn Center',
        href: 'https://www.policygenius.com/disability-insurance/learn/',
      },
      {
        title: 'Pet Insurance Learn Center',
        href: 'https://www.policygenius.com/pet-insurance/learn/',
      },
      {
        title: 'Renters Insurance Learn Center',
        href: 'https://www.policygenius.com/renters-insurance/learn/',
      },
    ]
  },
  [RESOURCES.GENIUS_CENTER]: {
    header: 'Magazine',
    items: [
      {
        title: 'Money',
        href: 'https://www.policygenius.com/blog/tag/money/',
      },
      {
        title: 'Tech',
        href: 'https://www.policygenius.com/blog/tag/technology/',
      },
      {
        title: 'How-Tos',
        href: 'https://www.policygenius.com/blog/tag/how-tos/',
      },
      {
        title: 'Interviews',
        href: 'https://www.policygenius.com/blog/tag/interviews/',
      },
      {
        title: 'News',
        href: 'https://www.policygenius.com/blog/tag/news/',
      },
    ]
  },
  [RESOURCES.HELPFUL_RESOURCES]: {
    header: 'Helpful Resources',
    items: [
      {
        title: 'Life Insurance Advice',
        href: 'https://www.policygenius.com/life-insurance/learn/shopping-advice/',
      },
      {
        title: 'Health Insurance Marketplace',
        href: 'https://www.policygenius.com/health-insurance/learn/how-to-shop-on-marketplaces-and-exchanges/'
      },
      {
        title: 'Obamacare',
        href: 'https://www.policygenius.com/health-insurance/faq/how-do-i-apply-for-obamacare/'
      },
      {
        title: 'Life Insurance Calculator',
        href: 'https://www.policygenius.com/life-insurance/life-insurance-calculator/'
      },
    ]
  },
  [RESOURCES.REVIEWS]: {
    header: 'Reviews',
    items: [
      {
        title: 'Trust Pilot Reviews',
        href: 'https://www.trustpilot.com/review/policygenius.com'
      }
    ]
  },
  [RESOURCES.ABOUT]: {
    header: 'About',
    items: [
      {
        title: 'Our Story',
        href: 'https://www.policygenius.com/about/',
      },
      {
        title: 'Values',
        href: 'https://www.policygenius.com/about/values/',
      },
      {
        title: 'Team',
        href: 'https://www.policygenius.com/about/team/',
      },
      {
        title: 'Careers',
        href: 'https://www.policygenius.com/careers/',
      },
      {
        title: 'Press',
        href: 'https://www.policygenius.com/about/press/',
      },
      {
        title: 'FAQ',
        href: 'https://www.policygenius.com/about/faq/',
      },
      {
        title: 'Partnerships',
        href: 'http://visit.policygenius.com/affiliate-partners/',
      }
    ]
  },

};



// WEBPACK FOOTER //
// ../src/templates/Footer/data/resources.js